// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file platform/websocket/wsevent/v1/auth.proto (package platform.websocket.wsevent.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";

/**
 * @generated from message platform.websocket.wsevent.v1.AuthRequest
 */
export const AuthRequest = /*@__PURE__*/ proto3.makeMessageType(
  "platform.websocket.wsevent.v1.AuthRequest",
  () => [
    { no: 1, name: "bearer_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message platform.websocket.wsevent.v1.AuthResponse
 */
export const AuthResponse = /*@__PURE__*/ proto3.makeMessageType(
  "platform.websocket.wsevent.v1.AuthResponse",
  [],
);

